import { render, staticRenderFns } from "./div-notice.vue?vue&type=template&id=2cc996db&scoped=true"
import script from "./div-notice.vue?vue&type=script&lang=js"
export * from "./div-notice.vue?vue&type=script&lang=js"
import style0 from "./div-notice.vue?vue&type=style&index=0&id=2cc996db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc996db",
  null
  
)

export default component.exports